import type {FC} from 'react';
import React from 'react';
import {useSelector} from 'react-redux';
import Selectors from "~/state/selectors.ts";


export const ErpUiAdminDetails: FC = () => {
    const settings = useSelector(Selectors.getSettings);
    const canEditWorktags: boolean = settings?.links?.chartfields?.href;
    return (
        <React.Fragment>
            <ul>
                <li>Assign the ERP Admin role</li>
                <li>View/Update terms</li>
                {canEditWorktags && <React.Fragment>
                    <li>View/Update GL Templates</li>
                    <li>View/Update local chart fields</li>
                </React.Fragment>}

            </ul>
        </React.Fragment>
    );
};

export default ErpUiAdminDetails;
